// extracted by mini-css-extract-plugin
module.exports = {"BuildControls":"BuildControls_BuildControls__3JwwJ","OrderButton":"BuildControls_OrderButton__26ils"};